<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <i class="el-icon-menu"></i>
    </div>
    <div class="logo" style="width: auto">警报点({{pointName}})</div>
    <div class="header-right">
      <el-button type="primary" style="margin-top: 15px; margin-right: 100px" icon="el-icon-caret-left" @click="gotoHome">返回</el-button>
    </div>
  </div>
</template>
<script>
  import bus from './bus';

  export default {
    name:'AlarmHeader',
    props:['pointName'],
    data() {
      return {
        alarmPointId:'',
        collapse: true,
        fullscreen: false,

      }
    },
    methods:{

      // 侧边栏折叠
      collapseChage(){
        this.collapse = !this.collapse;
        bus.$emit('collapse', this.collapse);
      },
      // 全屏事件
      handleFullScreen(){
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
      gotoHome(){
        // this.$router.push(this.lastRouter);
        window.close();
      }

    },
    // mounted(){
    //   console.log('pointName');
    //   console.log(this.$store.state.AlarmPointStaticInfomation)
    //   this.pointName = this.$store.state.AlarmPointStaticInfomation.result.pointName;
    // },
    computed:{
      alarmPointId (){
        // return this.$store.state.alarmPointId;
        return sessionStorage.getItem('alarmPointId');
      },
      lastRouter (){
        // return this.$store.state.lastRouter;
        return sessionStorage.getItem('lastRouter');
      },
      // pointName(){
      //   console.log('改变了');
      //   console.log(this.$store.state.AlarmPointStaticInfomation.result.pointName);
      //   return this.$store.state.AlarmPointStaticInfomation.result.pointName;
      // }
    },
  }
</script>
<style scoped>
  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
  }
  .collapse-btn{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
  }
  .header .logo{
    float: left;
    width:250px;
    line-height: 70px;
  }
  .header-right{
    float: right;
    padding-right: 50px;
  }
  .header-user-con{
    display: flex;
    height: 70px;
    align-items: center;
  }
  .btn-fullscreen{
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
  }
  .btn-bell, .btn-fullscreen{
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
  }
  .btn-bell-badge{
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
  }
  .btn-bell .el-icon-bell{
    color: #fff;
  }
  .user-name{
    margin-left: 10px;
  }
  .user-avator{
    margin-left: 20px;
  }
  .user-avator img{
    display: block;
    width:40px;
    height:40px;
    border-radius: 50%;
  }
  .el-dropdown-link{
    color: #fff;
    cursor: pointer;
  }
  .el-dropdown-menu__item{
    text-align: center;
  }
</style>
